// Shipments table columns, shared with SettingsView so users can pick
// which columns to hide.
export default [
  { text: "Order #", value: "order" },
  { text: "Age", value: "createdAt" },
  { text: "Notes", value: "order.notes", sortable: false },
  {
    text: "Ship By",
    value: "order.shipBy",
  },
  { text: "State", value: "order.address.state", sortable: false },
  {
    text: "Assigned To",
    value: "user.name",
    sortable: false,
  },
  { text: "Order Tags", value: "order.tags", sortable: false },
  { text: "Item Locations", value: "orderItems.location" },
  { text: "Box", value: "box" },
  { text: "Items", value: "orderItems", width: "25%" },
];
